const LangEgiftCardDetails = {
	"egiftCardDetails.nameOfThePersonYouWishToSendTheGiftCardTo": [
		"Name of the person you wish to send the gift card",
		"Tên của người bạn mà bạn muốn gửi quà tặng này",
	],
	"egiftCardDetails.typeYourMessageToTheRecipientHere": [
		"Type your message to the recipient here, up to 255 characters",
		"Nhập tin nhắn bạn muốn gửi tại đây. Tối đa 225 ký tự",
	],
	"egiftCardDetails.thisGiftIsFrom": ["This gift is from", "Món quà này từ"],
	"egiftCardDetails.yourName": ["Your name", "Tên người gửi"],
	"egiftCardDetails.yourEmailAddress": ["Your E-mail Address", "Email của người gửi"],
	"egiftCardDetails.confirmYourEmail": [
		"Confirm Your E-mail",
		"Xác nhận email của bạn",
	],
	"egiftCardDetails.deliverThisGiftTo": ["Deliver this gift to", "Món quà này gửi đến"],
	"egiftCardDetails.recipientName": ["Recipient Name", "Tên người nhận"],
	"egiftCardDetails.recipientEmailAddress": [
		"Recipient E-mail Address",
		"Email người nhận",
	],
	"egiftCardDetails.confirmRecipientEmailAddress": [
		"Confirm Recipient E-mail Address",
		"Xác nhận email người nhận",
	],
	"egiftCardDetails.egiftValueIsBelow": [
		"Please input a valid amount between VND 100,000 to VND 5,000,000.",
		"Số tiền không hợp lệ, vui lòng chọn số tiền từ VND 100,000 đến VND 5,000,000",
	],
	"egiftCardDetails.egiftValueIsAbove": [
		"Please input a valid amount between VND 100,000 to VND 5,000,000.",
		"Số tiền không hợp lệ, vui lòng chọn số tiền từ VND 100,000 đến VND 5,000,000",
	],
	"egiftCardDetails.validation.required": ["Required", "Bắt buộc"],
	"egiftCardDetails.validation.html": [
		"Please input a valid format",
		"Vui lòng nhập định dạng hợp lệ",
	],
	"egiftCardDetails.validation.special.character": [
		"Please do not input special character (eg:!, @, #, $, %, ^, &, *)",
		"Vui lòng không dùng ký tự đặc biệt (eg:!, @, #, $, %, ^, &, *)",
	],
	"egiftCardDetails.validation.emailNotMatch": [
		"Email does not match",
		"Email không trùng khớp",
	],
	"egiftCardDetails.validation.emailInvalid": ["Email invalid", "Email không hợp lệ"],
}

export default LangEgiftCardDetails



// WEBPACK FOOTER //
// ./src/resources/pages/LangEgiftCardDetails.js